import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BodisplayComponent } from './bodisplay.component';
import { DynamicTagGroupModule } from './dynamic-tag-group';
import { PipeModule } from '../pipes';
import { ModalModule } from '../modal';
import { BoBaseComponent } from './bo.base.component';
import { DragModalModule } from '../modal-draggable';
import { BoAdminBaseComponent, AdminBoDataComponent, AdminPropDataComponent } from './admin';
import { SelectModule } from '../select';
import { TemplateModule } from './template/template.module';
import { DateModule } from '../date';
import { SavedModelsModule } from './saved-models';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CdkScrollableModule } from '@angular/cdk/scrolling';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
    PipeModule,
    DynamicTagGroupModule,
    DragDropModule,
    CdkScrollableModule,
    SavedModelsModule,
    ModalModule,
    DragModalModule,
    SelectModule,
    TemplateModule,
    DateModule
  ],
  declarations: [
    BoBaseComponent,
    BodisplayComponent,
    BoAdminBaseComponent,
    AdminBoDataComponent,
    AdminPropDataComponent,
  ],
  exports: [
    BodisplayComponent,
    AdminBoDataComponent,
    AdminPropDataComponent
  ]
})

export class BodisplayModule { }
